export const routeMappings = {
    rescheduleConfirm: '/reschedule-appointment-confirmed'
}
